import { render, staticRenderFns } from "./QuotesListSortsFields.vue?vue&type=template&id=1be317eb&scoped=true&"
import script from "./QuotesListSortsFields.vue?vue&type=script&lang=js&"
export * from "./QuotesListSortsFields.vue?vue&type=script&lang=js&"
import style0 from "./QuotesListSortsFields.vue?vue&type=style&index=0&id=1be317eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be317eb",
  null
  
)

export default component.exports